<template>
    <img
        :src="`https://flagcdn.com/w40/${countryCode.toLowerCase()}.webp`"
        :srcset="`https://flagcdn.com/w80/${countryCode.toLowerCase()}.webp 2x`"
        @error="onFlagLoadError"
    />
</template>

<script setup lang="ts">
import { PALE_PLACEHOLDER_IMAGE_URL } from 'widget-components/utilities/placeholders'

defineProps<{
    countryCode: string
}>()

const onFlagLoadError = (event: Event) => {
    const imgElement = event.target as HTMLImageElement
    imgElement.src = PALE_PLACEHOLDER_IMAGE_URL
    imgElement.removeAttribute('srcset')
}
</script>
